module.exports = __webpack_public_path__ + "img/file---4393@1x.5d1eb691.png";